const showMoreCards = {
    init: (cards, button, colType) => {

        if (!button || !colType) return;

        if (cards.length > colType) {
            button.addEventListener('click', (e) => showMoreCards.displayAdditionalCards(e, button, cards));
        } else {
            showMoreCards.hideShowMoreButton(button);
        }
    },

    displayAdditionalCards: (e, button, cards) => {
        e.preventDefault();
        cards.forEach(card => {
            if (card.classList.contains('display-none')) card.classList.remove('display-none');
        });
        showMoreCards.hideShowMoreButton(button);
    },

    hideShowMoreButton: (button) => {
        button.classList.add('display-none');
    }
}


document.addEventListener('DOMContentLoaded', function () {
    const showMoreCardSection = document.querySelectorAll('.mod-show-more-cards');

    showMoreCardSection.forEach((section) => {
        const cards = section.querySelectorAll('.mod-flex-cards__card');
        const showMorebutton = section.querySelector('.plus-link');

        const stepClassNameAttr = section.getAttribute('data-step-class-name');
        const colType = stepClassNameAttr === 'mod-flex-cards--3-col' ? 3 : 4;
        
        showMoreCards.init(cards, showMorebutton, colType);
    });
});